export default "/images/9e4f51dae9bd79cce63512dd36d5bb96.avif";